import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { mediumMap } from '@/helpers/data';
import { Medium } from '@/domain/types';
import { ActionStatus } from '@/application/types';
import { Order } from '../../types';

const orderSearchState = namespace('orderSearch');

@Component
export default class PositionsTab extends Vue {

  @orderSearchState.State
  readonly currentOrder!: Order | null;

  @orderSearchState.State
  readonly getOrderIdentificationsByOrderNumberStatus!: ActionStatus;

  @orderSearchState.State
  readonly getCurrentOrderStatus!: ActionStatus;

  get isLoading(): boolean {
    return this.getCurrentOrderStatus === ActionStatus.InProgress
      || this.getOrderIdentificationsByOrderNumberStatus === ActionStatus.InProgress;
  }

  translatedMedium(medium: Medium): string {
    return mediumMap[medium];
  }

}
